module.exports = __webpack_public_path__ + "img/surdurulebilirlik.c4192d07.png";